import { check } from './check';
import { extract } from './extract';
import { integration } from './integration';
import { integral } from './integral';
import { maxY } from './maxY';
import { maxYPoint } from './maxYPoint';
import { minYPoint } from './minYPoint';
import { reduce } from './reduce';
import { growingX } from './growingX';
import { minClosestYPoint } from './minClosestYPoint';
import { maxClosestYPoint } from './maxClosestYPoint';
import { realMinYPoint } from './realMinYPoint';
import { realMaxYPoint } from './realMaxYPoint';
import { maximaY } from './maximaY';
import { minimaY } from './minimaY';
import { peakInfo } from './peakInfo';
import { toXYObject } from './toXYObject';

export const XY = {
  check,
  extract,
  integral,
  integration,
  maxY,
  maximaY,
  maxYPoint,
  minimaY,
  minYPoint,
  reduce,
  growingX,
  minClosestYPoint,
  maxClosestYPoint,
  realMaxYPoint,
  realMinYPoint,
  peakInfo,
  toXYObject,
};
